/* HEADER v4 behaviour: mega menu (hover + keyboard/touch), country/currency dropdown, mobile drawer
   with sliding sub-views and accordions, live header height (--site-header-h) and empty cart badge. No jQuery. */
(function () {
  'use strict';
  var root = document.querySelector('[data-hv4]');
  if (!root) return;
  var html = document.documentElement;
  var desktop = window.matchMedia('(min-width: 992px)');

  /* ---- header height → --site-header-h (pages reserve space with it) ---- */
  function setHeight() {
    if (root.offsetParent === null && getComputedStyle(root).display === 'none') return;
    var h = Math.round(root.getBoundingClientRect().height);
    if (h > 0) html.style.setProperty('--site-header-h', h + 'px');
  }
  setHeight();

  /* ---- line the mega panel up with the logo's left edge ---- */
  var bar = root.querySelector('.hv4-bar');
  var logoImg = root.querySelector('.hv4-logo__img, .hv4-logo__text');
  function alignMega() {
    if (!bar || !logoImg || !desktop.matches) return;
    var x = Math.round(logoImg.getBoundingClientRect().left - bar.getBoundingClientRect().left);
    if (x >= 0) bar.style.setProperty('--hv4-mega-x', x + 'px');
  }
  alignMega();
  window.addEventListener('load', alignMega);
  window.addEventListener('resize', alignMega, { passive: true });
  if (logoImg && logoImg.tagName === 'IMG' && !logoImg.complete) logoImg.addEventListener('load', alignMega);
  window.addEventListener('load', setHeight);
  window.addEventListener('resize', setHeight, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(setHeight).observe(root);

  /* ---- cart badge: hide at 0 (other scripts rewrite [data-cart-count]) ---- */
  var badge = root.querySelector('.hv4-cart__count');
  var countEl = badge && badge.querySelector('[data-cart-count]');
  function syncBadge() {
    if (!badge) return;
    var n = parseInt((countEl ? countEl.textContent : badge.textContent).trim(), 10) || 0;
    badge.classList.toggle('is-empty', n === 0);
  }
  syncBadge();
  if (badge && 'MutationObserver' in window) new MutationObserver(syncBadge).observe(badge, { childList: true, subtree: true, characterData: true });

  /* ---- mega menu ---- */
  var megaItems = Array.prototype.slice.call(root.querySelectorAll('[data-hv4-mega]'));
  function closeMegas(except) {
    megaItems.forEach(function (li) {
      if (li === except) return;
      li.classList.remove('is-open');
      var a = li.querySelector('.hv4-nav__link'); if (a) a.setAttribute('aria-expanded', 'false');
    });
  }
  megaItems.forEach(function (li) {
    var link = li.querySelector('.hv4-nav__link');
    li.addEventListener('mouseenter', function () { li.classList.remove('is-closed'); link.setAttribute('aria-expanded', 'true'); });
    li.addEventListener('mouseleave', function () { li.classList.remove('is-open', 'is-closed'); link.setAttribute('aria-expanded', 'false'); });
    // Touch / pen: first tap opens the panel, second tap follows the link.
    link.addEventListener('click', function (e) {
      if (li.classList.contains('is-open') || window.matchMedia('(hover: hover)').matches) return;
      e.preventDefault(); closeMegas(li); li.classList.add('is-open'); link.setAttribute('aria-expanded', 'true');
    });
    li.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { li.classList.remove('is-open'); li.classList.add('is-closed'); link.setAttribute('aria-expanded', 'false'); link.focus(); }
      if ((e.key === 'ArrowDown') && e.target === link) {
        e.preventDefault(); li.classList.remove('is-closed'); li.classList.add('is-open'); link.setAttribute('aria-expanded', 'true');
        var first = li.querySelector('.hv4-mega a'); if (first) first.focus();
      }
    });
    li.addEventListener('focusout', function (e) {
      if (!li.contains(e.relatedTarget)) { li.classList.remove('is-open', 'is-closed'); link.setAttribute('aria-expanded', 'false'); }
    });
  });

  /* ---- country / currency dropdown ---- */
  var loc = root.querySelector('[data-hv4-loc]');
  if (loc) {
    var locBtn = loc.querySelector('[data-hv4-loc-toggle]');
    var setLoc = function (open) { loc.classList.toggle('is-open', open); locBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); };
    locBtn.addEventListener('click', function (e) { e.stopPropagation(); setLoc(!loc.classList.contains('is-open')); });
    document.addEventListener('click', function (e) { if (!loc.contains(e.target)) setLoc(false); });
    loc.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setLoc(false); locBtn.focus(); } });
  }

  /* ---- mobile drawer ---- */
  var drawer = root.querySelector('[data-hv4-drawer]');
  var opener = root.querySelector('[data-hv4-drawer-open]');
  if (drawer && opener) {
    var views = Array.prototype.slice.call(drawer.querySelectorAll('[data-hv4-view]'));
    var lastFocus = null;
    var showView = function (name) {
      views.forEach(function (v) {
        var on = v.getAttribute('data-hv4-view') === name;
        v.classList.toggle('is-active', on);
        v.classList.toggle('is-left', !on && v.getAttribute('data-hv4-view') === 'root');
        v.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) { v.scrollTop = 0; var f = v.querySelector('.hv4-view__back, .hv4-mlist__row'); if (f && drawer.classList.contains('is-open')) f.focus({ preventScroll: true }); }
      });
    };
    var openDrawer = function () {
      lastFocus = document.activeElement;
      showView('root');
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
      opener.setAttribute('aria-expanded', 'true'); html.classList.add('hv4-lock');
      var c = drawer.querySelector('.hv4-view.is-active .hv4-drawer__close'); if (c) c.focus({ preventScroll: true });
    };
    var closeDrawer = function () {
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
      opener.setAttribute('aria-expanded', 'false'); html.classList.remove('hv4-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };
    opener.addEventListener('click', openDrawer);
    drawer.addEventListener('click', function (e) {
      var t = e.target.closest('[data-hv4-drawer-close], [data-hv4-goto], [data-hv4-acc]');
      if (!t) return;
      if (t.hasAttribute('data-hv4-drawer-close')) closeDrawer();
      else if (t.hasAttribute('data-hv4-goto')) showView(t.getAttribute('data-hv4-goto'));
      else {
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        var open = t.getAttribute('aria-expanded') !== 'true';
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.hidden = !open;
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
    var onBp = function () { if (desktop.matches && drawer.classList.contains('is-open')) closeDrawer(); };
    if (desktop.addEventListener) desktop.addEventListener('change', onBp); else desktop.addListener(onBp);
  }

  /* ---- inline search ----
     Desktop: the search icon swaps the nav for a search field inside the bar (no slide-down overlay).
     Drawer: the drawer's search fields get the same live results.
     Suggestions: /search/suggest (Shopify predictive queries). Products: matched against the product list of the
     collection in data-collection (Header v4 › "Products shown in search"; default all-products, same collection as
     the search results page), both via sections/predictive-search-v4.liquid. */
  var PS_SECTION = 'predictive-search-v4';
  var PS_MAX = 6;
  var psRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var psCache = {};

  function psFetch(url) {
    if (psCache[url]) return psCache[url];
    psCache[url] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); })
      .catch(function (e) { delete psCache[url]; throw e; });
    return psCache[url];
  }


  /* Product list of the search collection, loaded once per visit (sessionStorage, 15 min). */
  var psIndexes = {};
  function psIndex(handle, sort) {
    var id = handle + '|' + (sort || '');
    if (psIndexes[id]) return psIndexes[id];
    var key = 'hv4-ps-index-v2:' + id;
    try {
      var cached = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (cached && Date.now() - cached.at < 9e5) return (psIndexes[id] = Promise.resolve(cached.list));
    } catch (e) {}
    /* sort=best-selling → Shopify's own best-selling order (units sold); otherwise the collection's admin sort */
    var qs = '?section_id=' + PS_SECTION + (sort === 'best-selling' ? '&sort_by=best-selling' : '');
    psIndexes[id] = psFetch(psRoot + 'collections/' + encodeURIComponent(handle) + qs).then(function (doc) {
      var el = doc && doc.querySelector('[data-ps-index]');
      var list = el ? JSON.parse(el.textContent) : [];
      try { sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), list: list })); } catch (e) {}
      return list;
    }).catch(function (e) { delete psIndexes[id]; throw e; });
    return psIndexes[id];
  }
  function psNorm(s) { return String(s || '').toLowerCase().replace(/[\u2122\u00ae\u00a9]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function psEsc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* Ranking — every typed word must start a word in the title (or, as a fallback, in the product type / tags):
       1. exact title match                ("inno shred" → Inno Shred™)
       2. Header v4 › "Priority products in search", in the order listed there
       3. title starts with the search      ("inno" → Inno …)
       4. other title matches, then type / tag matches (tag matches only when titles give fewer than 3 hits)
     Ties follow Header v4 › "Rank matching products by": best selling (Shopify's units-sold order) or the collection's
     admin sort. Out of stock goes last. */
  function psMatch(list, q, priority) {
    var words = psNorm(q).split(' ').filter(Boolean);
    if (!words.length) return [];
    var nq = words.join(' ');
    var prio = {};
    (priority || []).forEach(function (h, i, arr) { prio[h] = arr.length - i; });
    var hits = [];
    list.forEach(function (p, i) {
      var t = ' ' + psNorm(p.t) + ' ';
      var rest = ' ' + psNorm(p.y + ' ' + p.g) + ' ';
      var inTitle = words.every(function (w) { return t.indexOf(' ' + w) > -1; });
      var anywhere = inTitle || words.every(function (w) { return t.indexOf(' ' + w) > -1 || rest.indexOf(' ' + w) > -1; });
      if (!anywhere) return;
      var score = inTitle ? 1000 : 0;
      if (t.trim() === nq) score += 10000;
      if (prio[p.h]) score += 500 + prio[p.h];
      else if (t.indexOf(' ' + nq) === 0) score += 100;
      if (p.a === false) score -= 100000;
      hits.push({ p: p, s: score, i: i, title: inTitle });
    });
    if (hits.filter(function (h) { return h.title; }).length >= 3) hits = hits.filter(function (h) { return h.title; });
    hits.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
    return hits.map(function (h) { return h.p; });
  }

  function initSearch(box) {
    var form = box.querySelector('form');
    var input = form && form.querySelector('input[name="q"]');
    var panel = box.querySelector('[data-ps-panel]');
    if (!input || !panel) return;
    var qWrap = panel.querySelector('[data-ps-queries]');
    var pWrap = panel.querySelector('[data-ps-products]');
    var empty = panel.querySelector('[data-ps-empty]');
    var allLink = panel.querySelector('[data-ps-all]');
    var termEl = panel.querySelector('[data-ps-term]');
    var clearBtn = box.querySelector('[data-ps-clear]');
    var collection = (box.getAttribute('data-collection') || 'all-products').trim();
    var sortBy = (box.getAttribute('data-sort') || 'best-selling').trim();
    var priority = (box.getAttribute('data-priority') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    var view = box.closest('.hv4-view');
    var timer = null, seq = 0, active = -1;

    function items() { return Array.prototype.slice.call(panel.querySelectorAll('[data-ps-item]')).filter(function (el) { return el.offsetParent !== null; }); }
    function setActive(i) {
      var list = items();
      list.forEach(function (el) { el.classList.remove('is-active'); });
      active = list.length ? (i + list.length) % list.length : -1;
      if (active > -1) { list[active].classList.add('is-active'); list[active].scrollIntoView({ block: 'nearest' }); }
    }
    function show(open) {
      panel.hidden = !open;
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (view) view.classList.toggle('is-searching', open);
    }
    function searchUrl(q) { return psRoot + 'search?q=' + encodeURIComponent(q) + '&type=product,article'; }

    function run() {
      var q = input.value.trim();
      if (clearBtn) clearBtn.hidden = !input.value;
      if (q.length < 2) { show(false); return; }
      var my = ++seq;
      termEl.textContent = q;
      allLink.href = searchUrl(q);
      panel.classList.add('is-loading');
      var url = psRoot + 'search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=query&resources[limit]=6&section_id=' + PS_SECTION;
      Promise.all([psFetch(url).catch(function () { return null; }), psIndex(collection, sortBy).catch(function () { return []; })]).then(function (res) {
        if (my !== seq) return;
        var qDoc = res[0], index = res[1];
        var qPart = qDoc && qDoc.querySelector('[data-ps-part="queries"]');
        var qs = qPart ? Array.prototype.slice.call(qPart.children) : [];
        qWrap.innerHTML = '';
        qs.forEach(function (a) { a.setAttribute('role', 'option'); qWrap.appendChild(a); });
        panel.classList.toggle('no-queries', qs.length === 0);

        var ps = psMatch(index, q, priority).slice(0, PS_MAX);
        pWrap.innerHTML = ps.map(function (p) {
          return '<a class="hv4-ps__p" href="' + psEsc(p.u) + '" data-ps-item role="option">' +
            '<span class="hv4-ps__img">' + (p.i ? '<img src="' + psEsc(p.i) + '" width="100" height="100" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="hv4-ps__name">' + psEsc(p.t) + '</span></a>';
        }).join('');
        empty.hidden = ps.length > 0;

        panel.classList.remove('is-loading');
        active = -1;
        show(true);
      });
    }

    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 220); });
    input.addEventListener('focus', function () { if (input.value.trim().length > 1 && (qWrap.children.length || pWrap.children.length)) show(true); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (panel.hidden) run(); else setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Enter' && active > -1) { var el = items()[active]; if (el) { e.preventDefault(); window.location.href = el.href; } }
      else if (e.key === 'Escape') { if (!panel.hidden) { e.stopPropagation(); show(false); } }
    });
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; clearBtn.hidden = true; show(false); input.focus(); });
    form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });
    document.addEventListener('click', function (e) { if (!box.closest('.hv4-sside, .hv4-drawer') && !box.contains(e.target)) show(false); });
    if (clearBtn) clearBtn.hidden = !input.value;
    box._psClose = function () { show(false); };
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-hv4-ps]'), initSearch);

  /* desktop: search sidebar (styled like the stack-options sidebar) */
  var sSide = root.querySelector('[data-hv4-sside]');
  var sOpen = root.querySelector('[data-hv4-search-open]');
  if (sSide && sOpen) {
    var sInput = sSide.querySelector('input[name="q"]');
    var sBox = sSide.querySelector('[data-hv4-ps]');
    var sLast = null;
    var openSearch = function () {
      closeMegas();
      sLast = document.activeElement;
      sSide.classList.add('is-open');
      sSide.setAttribute('aria-hidden', 'false');
      sOpen.setAttribute('aria-expanded', 'true');
      html.classList.add('hv4-lock-search');
      if (sInput) setTimeout(function () { sInput.focus({ preventScroll: true }); var v = sInput.value; sInput.value = ''; sInput.value = v; }, 60);
    };
    var closeSearch = function () {
      if (!sSide.classList.contains('is-open')) return;
      sSide.classList.remove('is-open');
      sSide.setAttribute('aria-hidden', 'true');
      sOpen.setAttribute('aria-expanded', 'false');
      html.classList.remove('hv4-lock-search');
      (sLast && sLast.focus ? sLast : sOpen).focus({ preventScroll: true });
    };
    sOpen.addEventListener('click', openSearch);
    sSide.addEventListener('click', function (e) { if (e.target.closest('[data-hv4-search-close]')) closeSearch(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !sSide.classList.contains('is-open')) return;
      var panel = sBox && sBox.querySelector('[data-ps-panel]');
      if (panel && !panel.hidden && document.activeElement === sInput) return; /* first Esc closes the results */
      closeSearch();
    });
    var onBpSearch = function () { if (!desktop.matches) closeSearch(); };
    if (desktop.addEventListener) desktop.addEventListener('change', onBpSearch); else desktop.addListener(onBpSearch);
  }
})();
